var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 3.7h-1.7v-.85a.85.85 0 0 0-1.7 0v.85h-5.1v-.85a.85.85 0 1 0-1.7 0v.85h-1.7A2.55 2.55 0 0 0 2 6.25v10.2A2.55 2.55 0 0 0 4.55 19h11.9A2.55 2.55 0 0 0 19 16.45V6.25a2.55 2.55 0 0 0-2.55-2.55m.85 12.75a.85.85 0 0 1-.85.85H4.55a.85.85 0 0 1-.85-.85V10.5h13.6zm0-7.65H3.7V6.25a.85.85 0 0 1 .85-.85h1.7v.85a.85.85 0 1 0 1.7 0V5.4h5.1v.85a.85.85 0 0 0 1.7 0V5.4h1.7a.85.85 0 0 1 .85.85z"
  })));
};
export default SvgCalendar;